<template>
    <div>
        <div class="button" @click="showList = !showList" v-if="!showList" key="button">
            <div>馈线柜列表</div>
            <img src="../../assets/img/箭头右.png" alt="">
        </div>
        <transition name="list">
            <div class="list" v-if="showList" key="list">
                <div class="title" @click="showList = false">
                    <div>馈线柜列表</div>
                    <img src="../../assets/img/箭头蓝.png" alt="">
                </div>
                <div class="content" id="cabinetDetailContent">
                    <el-tree :data="list" :props="defaultProps" default-expand-all highlight-current
                        :expand-on-click-node='false' @node-click="handleNodeClick">
                        <span class="custom-tree-node" slot-scope="{ node }">
                            <span>{{ node.label}}</span>
                            <i v-if="node.childNodes.length < 1" style="font-size:12rem">低压回路</i>
                        </span>
                    </el-tree>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    import {
        GetDeviceByAreaId,
        GetLoopsByDeviceId,
    } from "@/components/Request";

    export default {
        name: "CabinetList",
        props: ["areaId"],
        data() {
            return {
                // 设备列表
                showList: false,
                // 当前区域所有设备modelId
                allDeviceModelID: [],
                // 设备详情
                showDetail: false,
                // 树形设备列表
                list: [],
                // 当前设备信息
                currentDevice: {
                    modelId: '',
                    deviceImg: '',
                    deviceName: '',
                    deviceType: '',
                    deviceDetails: {},
                },
                defaultProps: {
                    children: 'children',
                    label: 'label'
                },
                loopsArr: []
            };
        },
        mounted() {
            GetDeviceByAreaId({
                projectId: this.$store.state.projectId
            }).then(({
                data
            }) => {
                let deviceIdArr = []
                let deviceList = data.data.devices.filter(item => item.area_id == this.areaId && item
                    .device_type_id == '14')
                deviceList.forEach((item1, index1) => {
                    this.list[index1] = {
                        label: item1.device_name,
                        modelId: item1.model_id,
                        deviceId: item1.device_id,
                        children: [],
                    }
                    deviceIdArr.push(item1.device_id)
                })
                deviceIdArr.forEach((item, index) => {
                    GetLoopsByDeviceId({
                        deviceId: item
                    }).then((json) => {
                        json.data.data.devices.filter(item => item.loopType !== 'BREAKER').forEach((item2, index2) => {
                            this.list[index].children[index2] = {
                                label: item2.loopName,
                                loopId: item2.loopId,
                                modelId: item2.modelId
                            }
                        })
                        this.loopsArr.push(...json.data.data.devices)
                    })
                })
            }).catch(err => {
                console.log(err)
            })
        },
        methods: {
            handleNodeClick(data, node, elem) {
                if (node.childNodes.length > 0) {
                    GetLoopsByDeviceId({
                        deviceId: data.deviceId
                    }).then((json) => {
                        // 展示馈线柜
                        this.$emit('showLoop', data.deviceId, data.modelId, json.data.data.devices.filter( item => item.loopType !== 'BREAKER'))
                    })
                } else if (node.childNodes.length == 0) {
                    GetLoopsByDeviceId({
                        deviceId: node.parent.data.deviceId
                    }).then((json) => {
                        // 展示具体的某条馈线回路
                        this.$emit('showLoopDetail', data.label, data.loopId, data.modelId, json.data.data
                            .devices.filter(item => item.loopType !== 'BREAKER'), this.loopsArr)
                        // 用于组件间通讯（右上角的监测数据和底部的馈线回路统一）
                        this.bus.$emit('changeLoop', this.areaId, data.loopId)
                    })
                }
            },
            handleClickPosition(node, data) {
                // console.log(node, data)
            },
        },
    };
</script>

<style lang="less" scoped>
    .button {
        .w(336);
        .h(56);
        background-image: url('../../assets/img/设备列表.png');
        background-size: 100% 100%;
        cursor: pointer;
        color: rgba(230, 243, 253, 0.7);
        font-size: 18rem;
        position: fixed;
        bottom: 1180/108vh;
        right: 4560/192vw;
        padding: 0 250/192vw;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        img {
            .w(7);
            .h(12);
        }
    }

    .list {
        .w(336);
        .h(300);
        background-image: url('../../assets/img/展开.png');
        background-size: 100% 100%;
        color: rgba(255, 255, 255, 0.7);
        font-size: 16rem;
        position: fixed;
        bottom: 1180/108vh;
        right: 4560/192vw;
        padding: 40/108vh 180/192vw;
        overflow: hidden;
        // display: flex;
        // flex-direction: column;
        // justify-content: flex-start;
        // align-items: center;


        .title {
            width: 100%;
            .h(50);
            font-size: 18rem;
            padding: 0 140/192vw 0 70/192vw;
            cursor: pointer;
            border-bottom: 1px solid rgba(255, 255, 255, 0.15);
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
        }

        .content {
            width: 100%;
            .h(235);
            overflow-y: auto;

            .el-tree {
                background: none;
            }

        }
    }

    .detail {
        .w(382);
        .h(448);
        position: fixed;
        top: 3310/108vh;
        left: 5220/192vw;
        background-image: url(../../assets/img/设备参数.png);
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;

        .head {
            width: 100%;
            .h(134);
            margin-top: 200/108vh;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            padding: 200/108vh 170/192vw 150/108vh;

            .pic {
                .w(96);
                .h(96);
                background: rgba(13, 148, 255, 0.2);
            }

            .data {
                width: 60%;
                .h(96);
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                font-size: 14rem;
                font-family: Source Han Sans CN;
                color: #60A9E2;
            }

            .close {
                .w(17);
                .h(17);
                cursor: pointer;
            }
        }

        .body {
            width: 100%;
            .h(275);
            overflow-y: auto;
        }
    }

    .content::-webkit-scrollbar {
        width: 50/192vw;
        height: 1px;
    }

    .content::-webkit-scrollbar-thumb {
        border-radius: 5px;
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: rgba(255, 255, 255, 0.7);
    }

    .body::-webkit-scrollbar {
        display: none;
        // width: 50/192vw;
        // height: 1px;
    }

    .body::-webkit-scrollbar-thumb {
        border-radius: 5px;
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: rgba(255, 255, 255, 0.7);
    }

    .list-enter,
    .list-leave-to {
        .h(56)
    }

    .list-enter-active,
    .list-leave-active {
        transition: height .5s
    }
</style>